export default {
    tdosTitle: {
        fontWeight: 600,
        fontSize: 13,
        margin: '5px 0',
    },
};
